export type State = {
  success: any | null;
  error: any | null;
}

export const state: State = {
  success: null,
  error: null,
};